import { Button, DatePicker, Form, Input, InputNumber, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { GET } from '../../../utils/requestActionConstants';
import { API_ROUTE } from '../../../utils/commonConstants';
import { fetcher } from '../../../helpers/processRequest';
import useSWR from 'swr';
import Barcode from 'react-barcode';
import { addInventory, getInventory, setInventory, updateInventory } from '../../../store/slices/inventorySlice';
import dayjs from 'dayjs';
import { STATUS } from '../../../utils/configConstants';
import { getInventoryBarCode } from '../../../utils/formatters';

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 6,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 14,
    },
  },
};

function AddInventory({ closeForm, onSwitchTab, tabProps = {} }) {
  const inventory = useSelector(getInventory);
  const product = useSelector(state => state.productSlice.product);
  const state = useSelector(state => state.inventorySlice);
  const categoryDataFetcher = useSWR({ method: GET, url: API_ROUTE + '/categories' }, fetcher);
  const categories = categoryDataFetcher.isLoading ? [] : categoryDataFetcher.data.data;
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  useEffect(() => {
    loadValues();
  }, [inventory]);

  const loadValues = () => {
    if (inventory.barcode || inventory.id) {
      form.setFieldsValue(inventory);
    } else {
      form.resetFields();
    }
  }

  const saveInventory = (data) => {
    if (inventory.id) {
      dispatch(updateInventory({ inventoryId: inventory.id, inventoryData: { ...data, productId: product.id } })).then(() => closeForm());
    } else {
      dispatch(addInventory({ inventoryData: { ...data, productId: product.id } })).then(() => closeForm());
    }
  }

  return (
    <div>
      <div className='text-center py-2 mb-10 font-bold p-5 rounded-lg mx-auto w-fit text-xl '>{inventory.id ? "Update Inventory" : "Add New Inventory"}</div>
      <Form
        disabled={state.loading.saving}
        form={form}
        layout='verticle'
        {...formItemLayout}
        style={{
          maxWidth: 600,
          margin: 'auto'
        }}
        onFinish={saveInventory}
      >
        <Form.Item
          label="Product Slug"
          name="slug"
          rules={[
            {
              required: true,
              message: 'Enter product slug  ',
            },
          ]}
        >
          <Input placeholder='Name of the slug' />
        </Form.Item>
        {/* <Form.Item
          label="Batch Number"
          name="batchNumber"
          disabled
          rules={[
            {
              required: true,
              message: '',
            },
          ]}

        >
          <Input placeholder='' />
        </Form.Item> */}
        {/* <Form.Item
          label="Bar Code"
          name="barcode"
          rules={[
            {
              required: true,
              message: '',
            },
          ]}
        >
          <Input />
        </Form.Item> */}
        <div className='text-center'>{inventory.id && <Barcode value={getInventoryBarCode(inventory.id)} className='m-auto' />}</div>
        <Form.Item
          label="Stock"
          name="stock"
          rules={[
            {
              required: true,
              message: 'Enter stock here',
            },
          ]}
        >
          <InputNumber placeholder='Enter stock' />
        </Form.Item>
        <Form.Item
          label="Price"
          name="price"
          rules={[
            {
              required: true,
              message: 'Enter inventory price here',
            },
          ]}
        >
          <InputNumber placeholder='Enter price' />
        </Form.Item>
        <Form.Item
          label="Cost Price"
          name="costPrice"
          rules={[
            {
              required: true,
              message: 'Enter cost price here',
            },
          ]}
        >
          <InputNumber placeholder='Enter cost price' />
        </Form.Item>
        <Form.Item
          label="Discount"
          name="discount"
          rules={[
            {
              required: true,
              message: 'Enter discount here',
            },
          ]}
        >
          <InputNumber placeholder='Enter discount' />
        </Form.Item>

        <Form.Item
          label="Expiry Date"
          name="expiryDate"
          rules={[
            {
              required: true,
              message: 'Enter expiry date here',
            },
          ]}
        >
          <DatePicker placeholder='Select expiry date' />
        </Form.Item>
        <Form.Item
          label="Manufactured Date"
          name="manufacturedDate"
          rules={[
            {
              required: true,
              message: 'Enter manufactured date here',
            },
          ]}
        >
          <DatePicker placeholder='Select manufactured date' />
        </Form.Item>

        <Form.Item
          label="Status"
          name="status"
          rules={[
            {
              required: true,
              message: 'Select Status',
            },
          ]}
        >
          <Select
            placeholder="Select Status"
          >
            <Select.Option value={STATUS.ACTIVE}>{STATUS.ACTIVE}</Select.Option>
            <Select.Option value={STATUS.INACTIVE}>{STATUS.INACTIVE}</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item wrapperCol={{ sm: { offset: 6, span: 14 }, xs: { offset: 0, span: 14 } }}>
          <div className='flex justify-between'>
            <Button type='primary' danger htmlType='submit' onClick={closeForm}>Close</Button>
            <div>{inventory.id ? <Button onClick={loadValues}>Revert Changes</Button> : <></>}</div>
            <div className='flex'>
              <Button danger type='text' htmlType='reset'>Clear</Button>
              <Button type='primary' htmlType='submit' loading={state.loading.saving}>{inventory.id ? "Update" : "Save"}</Button>
            </div>
          </div>
        </Form.Item>
      </Form>
    </div>
  )
}

export default AddInventory